//=============================================================================
// Contents   : HRDB
//              権限グループマスタ
//              GetAuthorityList
// Author     : RV奥村
// LastUpdate : 2023/04/12
// Since      : 2023/04/12
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  

/* ====== React ====== */
import React,{ useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useProvideData } from "03CommonApiParts/use-context";
/* ====== CSS ====== */
/* ====== Image ====== */
/* ====== Component Js/Jsx ====== */
/* ====== Style ====== */
import { screenMaster, USERINFO_STORAGE } from "03CommonApiParts/CodeDefinition";
import { CFArrayFount, CFCheckArrayData, CFCreateApplyList, CFJsonIgnore, CFStringDecodeJP, CFStringEncodeJP, checkChangeFlag, confirmChange } from "03CommonApiParts/CommonFunction";
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";
import { Table } from "02CommonUiParts/TableParts/Table";
import { useFieldArray, useForm } from "react-hook-form";
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { StyleCommon } from "01Pages/Common/Style/StyleCommon";
import { LeftTitleTable } from "02CommonUiParts/TableParts/LeftTitleTable";
import { Title } from "01Pages/Common/UiParts/Title";
import { TableArray } from "02CommonUiParts/TableParts/TableArray";
import { Underbar } from "02CommonUiParts/OtherParts/Underbar";
import { screenDisplayMessage } from "03CommonApiParts/MessageList";
import { ButtonIconCopyRegister } from "02CommonUiParts/ButtonParts/ButtonBase";
import { Dialog } from "02CommonUiParts/MessageParts/Dialog";
/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  
const CommonStyle = StyleCommon();//共通スタイルドコンポーネント
/* ベース64スイッチ */
const base64Swicth = true;	//エンコード処理スイッチ




/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */  

/* ========= 権限クループマスタ ========= */
export const GetAuthorityList = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    const navigate = useNavigate();//画面遷移用
    const apiData = useProvideData();//APIデータ取得
    const location = useLocation();

    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */
    // const keyList = Object.keys(showMaster)
    /* ====== sessionStorageからの情報を定義 ====== */ 
    /* USERINFO_STORAGEから従業員情報を取得 */
    const userInfoStorage = sessionStorage.getItem(USERINFO_STORAGE);
    var userInfoValue = JSON.parse(userInfoStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const userName = userInfoValue.empJpnSrname + ' ' + userInfoValue.empJpnName;//名前
    const screenId = CFArrayFount(screenMaster,'path',location.pathname).id;//画面Id
    /* ====== localStorageからの情報を定義 ====== */ 

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 


    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */

    const [loading, setLoading] = useState(false); //画面表示用
    const [progress, setProgress] = useState(false); //プログレスバー表示用
    const [dataRow, setDataRow] = useState({
        applyList:[],
        aplySrtDate:'',
        list:[]
    });
    const [confirm, setConfirm] = useState({});//確認用データ格納用
    const [newData, setNewData] = useState([]);//変更後データ格納用
    const [headData, setHeadData] = useState();//ヘッダーデータ
    const [confirmHeadData, setConfirmHeadData] = useState();//確認用ヘッダーデータ
    const [headData2, setHeadData2] = useState();//ヘッダーデータ2
    const [editHeadData, setEditHeadData] = useState();//ヘッダーデータ編集用
    const [bodyData, setBodyData] = useState();//ボディデータ
    const [confirmBodyData, setConfirmBodyData] = useState();//確認用ボディデータ
    const [editBodyData, setEditBodyData] = useState();//ボディデータ編集用
    const [mainSubCategoryList, setMainSubCategoryList] = useState();//大分類小分類の種類の格納先
    const [mainCategoryList, setMainCategoryList] = useState();//大分類の格納先
    const [pageMode, setPageMode] = useState('list');
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });
    const [dialogMessage, setDialogMessage] = useState({ //ダイアログ表示用
        open:false,
    });
    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== hookformを定義 ====== */ 
    const { register, getValues,setValue, handleSubmit,watch,control,formState: { errors } } = useForm({
        mode: 'onBlur',
        reValidateMode: 'onChange',
        shouldUseNativeValidation: false,
        shouldUnregister: false,
        escalationCode:false
    });
    const { fields, append, remove } = useFieldArray(
		{
			control,
			name: `payload.list`
		}
	);
    

    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */

    /* ====== 初期表示 ====== */ 
    useEffect(() => {
        /* APIデータ取得 */
        getMaster();
        // eslint-disable-next-line
    },[]);
	/* ====== マスタの取得処理 ====== */
    const getMaster = async(date) => {
        /* リクエスト先 */
        const apiPath = '/search/getmaster';
        /* リクエスト*/
        const handlingInformation = {};
        const key = {};

        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail;
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';

        /* キー */
        key.aplySrtDate = date ? date : null;
        key.mstList = ['authorityMaster'];//権限グループマスタ

        /* リクエストパラメータ */
        const apiBody = {handlingInformation:handlingInformation, key:key};

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* APIリクエスト結果を判定 */
            if(result.isSuccessed){//APIリクエスト結果 = 正常
                const data = result.responseData.data.payload;
                /* ======== 可変テーブルの設定 ======== */
                /*------ ヘッダの設定 ------*/
                // id       : 項目名
                // id2       : 項目名2
                // rowSpan  : 2~ (縦に結合)
                // colSpan	: 2~ (横に結合)
                // align	: 整列(横方向) Center/inherit/justify/left/right
                // sortTable: true(ソート)
                // fixed	: 位置固定 true
                // left		: 左からの位置	0~
                // right	: 右からの位置 0~
                // width    : セルの幅
                // label1	: 表示名(1段目)
                // label2	: 表示名(2段目)
                // mark     : 入力必須を表す*を表示　true

                /* ====== テーブルヘッダーを定義 ====== */
                const head = [
                    { id: 'icon', align: 'center', width: '50px', label1: '対象', fixed:true,left:'0px', nowrap: true, blockHead: true, rowSpan:2},
                    { id: 'authGpCd', align: 'left', width: '130px', label1:'権限グループ',label2: 'コード', fixed:true, left:'55px', nowrap: true, blockHead: true, required: true,rowSpan:2},
                    { id: 'authGpName', align: 'left', width: '310px', label1:'権限グループ名',fixed:true,left:'190px', borderRight: '1px solid #c0c0c0', nowrap: true, blockHead: true, required: true,rowSpan:2}
                ];
                const confirmHead = [
                    { id: 'authGpCd', align: 'left', width: '130px', label1:'権限グループ',label2: 'コード', fixed:true, left:'0px', nowrap: true, blockHead: true, required: true,rowSpan:2},
                    { id: 'authGpName', align: 'left', width: '310px', label1:'権限グループ名',fixed:true,left:'133px', borderRight: '1px solid #c0c0c0', nowrap: true, blockHead: true, required: true,rowSpan:2}
                ];
                const head2 = [];
                /*====== BodyCellの設定 ======*/
                // name		    : 項目名
                // name2		: 項目名2 値を２つ受け取りたい場合
                // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
                // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
                // width        : selectの幅調整用
                // color        : 文字の色
                // backgroundColor: 背景の色
                // checkBox     : チェックボックスの名前  *input,checkBox
                // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
                // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
                // func         : 処理 *button,iconButton,select
                // value		: btnFuncで受け取りたい値 *button,iconButton

                /* ====== テーブルデータを定義 ====== */
                const body = [
                    { name: 'icon', type: 'authorityChangeButton',  align: 'center',fixed:true,left:'0px', nowrap: true, func: onClickUser, checkItem:'authGpCd', checkValue:'000'},
                    { name: 'authGpCd', type: 'label',  align: 'left',fixed:true, left:'55px', nowrap: true, required: true, maxLength:3,minLength:3,placeholder:'3文字',pattern:'number'},
                    { name: 'authGpName', type: 'label',  align: 'left',fixed:true, left:'190px', nowrap: true, required: true, borderRight: '1px solid #c0c0c0',maxLength:64,placeholder:'最大64文字',pattern:'space'}
                ];	
                const confirmBody = [
                    { name: 'authGpCd', type: 'label',  align: 'left',fixed:true, left:'0px', nowrap: true, required: true, maxLength:3,minLength:3,placeholder:'3文字',pattern:'number'},
                    { name: 'authGpName', type: 'label',  align: 'left',fixed:true, left:'133px', nowrap: true, required: true, borderRight: '1px solid #c0c0c0',maxLength:64,placeholder:'最大64文字',pattern:'space'}
                ];	
                /*　大分類_小分類の種類リスト */
                const mainSubList = [];
                /* 大分類のデータ格納先　*/
                const mainList = [];
                data[0].list.forEach((main,index)=>{
                    /* 大分類をセット　*/
                    mainList.push(main.value);
                    /* 小分類の個数をカウント */
                    const count = main.mstSubCtgrInfo.length;
                    /* header設定 */
                    const headObject = {};
                    headObject.label1 = CFStringDecodeJP(main.label,base64Swicth);
                    headObject.borderRight = '1px solid #c0c0c0';
                    headObject.align = 'center';
                    headObject.colspan = count;
                    count === 1 ? headObject.width = '230px' : headObject.width = `${count * 115}px`;//小分類が1つなら230px,小分類が1つ以上なら個数×115px
                    
                    main.mstSubCtgrInfo.forEach((sub,i)=>{
                        const headObject2 = {};
                        const bodyObject = {};
                        /* header2設定 */
                        headObject2.id = `${main.value}_${sub.mstSubCtgrIemCd}`;
                        headObject2.align = 'center';
                        headObject2.width = '97px';
                        headObject2.blockHead = true;
                        headObject2.nowrap = true;

                        /* 小分類の一つ目ならlabel1で大項目名を表示 */
                        headObject2.label1 = CFStringDecodeJP(sub.mstSubCtgrIemLabel,base64Swicth);
                        /* body設定 */
                        bodyObject.name = `${main.value}_${sub.mstSubCtgrIemCd}`;
                        bodyObject.type = 'check';
                        bodyObject.align = 'center';
                        bodyObject.disabled = true;
                        /* 大分類の一番右端の列でない＋小分類の一番右端である場合に、線を引く */
                        if((data[0].list.length - 1 !== index) && (main.mstSubCtgrInfo.length - 1 === i)){
                            headObject2.borderRight = '1px solid #c0c0c0';
                            bodyObject.borderRight = '1px solid #c0c0c0';
                        };
                        /* 大分類_小分類の種類データをプッシュ */
                        mainSubList.push(`${main.value}_${sub.mstSubCtgrIemCd}`);
                        /* データをプッシュ */
                        head2.push(headObject2);
                        body.push(bodyObject);
                        confirmBody.push(bodyObject);
                    });
                    /* データをプッシュ */
                    head.push(headObject);
                    confirmHead.push(headObject);
                });
                /* 大分類小分類の種類をセット */
                setMainSubCategoryList([...mainSubList,'authGpCd','authGpName']);
                /* 大分類の種類をセット */
                setMainCategoryList(mainList);
                /* 一覧表示用のデータセット */
                setHeadData(head);
                setConfirmHeadData(confirmHead);
                setHeadData2(head2);
                setBodyData(body);
                setConfirmBodyData(confirmBody);

                /* 一覧表示用のデータをコピー */
                const editHead = JSON.parse(JSON.stringify(head));
                const editBody = JSON.parse(JSON.stringify(body));

                /* 一覧表示用のデータでcheckのものとlabelのものを編集する */
                body.forEach((item,i)=>{
                    if(item.type === 'check'){
                        editBody[i].disabled = false;
                    }else if(item.type === 'label'){
                        editBody[i].type = 'input';
                        editBody[i].required = 'true';
                        editHead[i].required = 'true';
                    };
                });
                editHead.splice(0,1,{ id: 'deleteIcon', align: 'center', width: '50px',label1: '削除',rowSpan:2, fixed: true, left: '0px'})//対象ボタンと削除ボタンを入れ替え
                editBody.splice(0,1,{ name: 'deleteIcon', type: 'deleteIcon', align: 'center', fixed: true, left: '0px'})//対象ボタンと削除ボタンを入れ替え
                
                /* 一覧編集用のデータセット */
                setEditHeadData(editHead);
                setEditBodyData(editBody);

                /* データ取得 */
                date ? getData(date) : getData();

            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
            }

        });
    };
    const getData = async(date) =>{
        /* プログレスバー表示 */
        setProgress(true);
        const apiPath = '/master/getlistauthority';	//API Path

		/* リクエスト*/
		const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';
		
		/* キー */
		key.aplySrtDate = date ? date : null;

		/* リクエストパラメータ */
		const apiBody = {handlingInformation:handlingInformation, key:key};

        /* API処理開始 */
		await apiData.getDataPost(apiPath, apiBody, (result) => {
			/* プログレスバー非表示 */
			setProgress(false);
			if (result.isSuccessed) {//APIリクエスト結果 = 正常
                const data = result.responseData.data.payload;
                /* 適用開始日リストの作成　*/
                const createApplyList = CFCreateApplyList(data.aplySrtDateList,'aplySrtDate');
                let aplySrtDate;
                /* 権限グループ情報 */
                const editData = [];
                data.authGpInfo.forEach((authGpInfoItem)=>{
                   /* 適用開始日 */
                    aplySrtDate = authGpInfoItem.aplySrtDate;
                    /* 適用開始日 */
                    authGpInfoItem.authGpList.forEach((authGpListItem,index)=>{
                        const dataObject = {};
                        /* 権限グループコード */
                        dataObject.authGpCd = authGpListItem.authGpCd;
                        /* 権限グループ名 */
                        dataObject.authGpName = CFStringDecodeJP(authGpListItem.authGpName,base64Swicth);
                        authGpListItem.authList.forEach((authListItem)=>{
                            authListItem.authSubCtgrCdList.forEach((authSubCtgrCdListItem)=>{
                                /* 権限 */
                                dataObject[`${authListItem.authMinCtgrCd}_${authSubCtgrCdListItem}`] = true;
                            });
                        });
                        dataObject.id = index;
                        editData.push(dataObject);
                    });
                });
                const payload = {
                    applyList:createApplyList.applyList,
                    aplySrtDate:aplySrtDate,
                    list:editData,
                };
                setDataRow(payload);
                setValue('payload.aplySrtDate',payload.aplySrtDate);
                setValue('payload.list', payload.list);
                /* 一番最新の適用日と現在表示している適用開始日が同一 */
               if(createApplyList.futureList[0] === aplySrtDate){
                    /* 現在適用されている適用開始日と一番最新の適用開始日 */
                    if(CFArrayFount(createApplyList.applyList,'aplyFlag',true).value === createApplyList.futureList[0]){
                        setPageMode('futureList'); 
                    }else{
                        setPageMode('futureDeleteList');
                    }
               }else if(createApplyList.pastList.some(day => day === aplySrtDate)){
                    setPageMode('pastList') 
               }else{
                    setPageMode('list');
               };

			}else{//APIリクエスト結果 = 異常
                setValue('payload.list', []);
			    /* スナックバー表示 */
			    setSnackbarMessage({      
			        ...snackbarMessage,
			        open:true,
			        message:result,//APIによるエラー
			        $1:result.responseData ? result.responseData.data.metadata: '',//取得件数
			        type: 1,//APIエラー時:1,それ以外:2 
			        level:'error',//エラースナックバー
			    })
			}
		});
        /* 画面表示開始 */
        setLoading(true);
    };
    /* ===== 更新処理　===== */
    const updateData = async() =>{
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト先 */
        const apiPath = '/master/updateauthority';	//API Path
        /* リクエスト*/
        const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'UPDATE';

        /* キー */
        key.aplySrtDate = getValues('payload.aplySrtDate');

        /* データの形を変更する処理(リクエストの形) */
        const payload = [];
        newData.forEach((row)=>{
            /* データの形を整形 {approval_register:true} → {main:'approval', sub:'register'} */
            const mainSubList = [];
            const keys = Object.keys(row);
            keys.forEach((key)=>{
                if(row[key] === true){
                    mainSubList.push({
                        main:key.split('_')[0],
                        sub:key.split('_')[1]
                    })
                };
            });
            /*  権限リスト*/
            const authList = [];
            mainCategoryList.forEach((main)=>{
                const authSubCtgrCdList = []; 
                /* 権限小分類　*/
                mainSubList.forEach((item)=>{
                    if(item.main === main){
                        authSubCtgrCdList.push(item.sub)  
                    };
                });
                /* 1個以上権限が付与されていれば、権限リストに格納　*/
                if(authSubCtgrCdList.length > 0){
                    authList.push({
                        authMinCtgrCd:main,
                        authSubCtgrCdList:authSubCtgrCdList
                    });
                }
            });
            payload.push({
                authGpCd:row.authGpCd,
                authGpName:CFStringEncodeJP(row.authGpName,base64Swicth),
                authList:authList
            });
        });
        /* リクエストパラメータ */
        const apiBody = { handlingInformation:handlingInformation, key:key, payload:payload };
        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* プログレスバー非表示 */
            setProgress(false);
            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                /* プログレスバー非表示 */
				setProgress(false);
                navigate('/common/completion', {
                    state:{
                        title: '権限グループコードマスタメンテ編集完了', 
                        message: screenDisplayMessage('CMNI004'), //データの更新が完了しました。
                        button:[
                            {name: '一覧画面へ戻る', path:'/master/authority/list'},
                        ]
                    },
                    replace:true
                },);
            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                })
            };
        });
    };
    /* ===== 削除処理　===== */
    const deleteData = async() =>{
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト先 */
        const apiPath = '/master/deleteauthority';	//API Path
        /* リクエスト*/
        const handlingInformation = {};
        const key = {};
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'DELETE';

        /* キー */
        key.aplySrtDate = getValues('payload.aplySrtDate');

        /* リクエストパラメータ */
        const apiBody = { handlingInformation:handlingInformation, key:key };

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* プログレスバー非表示 */
            setProgress(false);

            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                navigate('/common/completion', {
                    state:{
                        title: '権限グループコードマスタメンテ削除完了', 
                        message: screenDisplayMessage('CMNI005'), //データの削除完了
                        button:[
                            {name: '一覧画面へ戻る', path:'/master/authority/list'},
                        ]
                    },
                    replace:true
                });
            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                })
            };
        });
    };
    
    /* ===データを修正する処理=== */
    const handleDataEdit = (datalist) =>{
        const result = [];
        datalist.forEach((row)=>{
            const keys = Object.keys(row);
            const object = {};
            keys.forEach((key)=>{
                if(row[key] !== undefined && row[key] !== false){
                    object[key] = row[key];
                };
            });
            row.id && (object.id = row.id);
            result.push(object);
        });
        return result;
    };
    /* === キャンセル・戻るボタンを押した時の処理=== */
    const onClickLeft = () => {

        if(pageMode === 'edit' || pageMode === 'register'){
            /* 変更前データ */
            let oldD = handleDataEdit(dataRow.list);
            /* 変更後データ */
            let newD = handleDataEdit(getValues('payload.list'));
            const changeOldData = [];
            const changeNewData = [];
           
            const afterCancel = () =>{
                getMaster();
            }
            /* 配列データの変更を確認して調整する処理 */
            CFCheckArrayData(oldD,newD,changeOldData,changeNewData,mainSubCategoryList);
            if(CFJsonIgnore(changeOldData) === CFJsonIgnore(changeNewData)){
                afterCancel();
            }else{
                /* 更新確認ダイアログ表示 */
                setDialogMessage({      
                    ...dialogMessage,
                    open: true,
                    message: 'CMNC001',//メッセージID(commonFunctionより対象のメッセージ)
                    afterFunc:afterCancel,
                    pattern:2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
                });
            }
            
        }else{
            setValue('payload.list',newData);
            pageMode === 'registerConfirm' ? setPageMode('register') : setPageMode('edit');
            
        }
    };

    /* ===　対象ボタンを押下 === */
    const onClickUser = (row) => {
        navigate('/master/user/list',{state:{authGpCd:row.authGpCd,authGpName:row.authGpName}});
    }

    /* === データ確認処理=== */
    const checkEditData = (data) =>{
        /* 変更前データ */
        let oldData = handleDataEdit(dataRow.list);
        /* 変更後データ */
        let newData = handleDataEdit(data.payload.list);
        
        /* 一つもチェックがない行がないかを確認　*/
        let unableFlag = false;
        newData.forEach((item)=>{
            if(Object.keys(item).some(s=>item[s] === true)){
            }else{
                unableFlag = true;
            }
        });
        if(unableFlag){
            /* スナックバー表示 */
            setSnackbarMessage({      
                ...snackbarMessage,
                open:true,
                message:'CMNW003',
                type: 2,//APIエラー時:1,それ以外:2 
                level:'error'//エラースナックバー
            });
        }
        /* デフォルトの存在確認 */
        else if(newData.some(item => item.authGpCd === '000')){
            const changeOldData = [];
            const changeNewData = [];
  
            /* 配列データの変更を確認して調整する処理 */
            CFCheckArrayData(oldData,newData,changeOldData,changeNewData,mainSubCategoryList)
                /* 変更点がない場合　*/
            if(CFJsonIgnore(changeOldData) === CFJsonIgnore(changeNewData)){
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:'CMNW004',
                    type: 2,//APIエラー時:1,それ以外:2
                });
            }else{
            /* 変更点がある場合　*/
                /* 変更があればchangeFlagをtrueにする */
                let changeFlags = checkChangeFlag(changeOldData,changeNewData, mainSubCategoryList);
                let changeData = confirmChange(changeFlags,changeOldData,changeNewData, mainSubCategoryList);
                /* 確認用データの格納 */
                setConfirm(
                    {
                        aplySrtDate:data.payload.aplySrtDate,
                        flags:changeFlags,
                        data:changeData
                    }
                );
               
                // /* 変更後データの格納 */
                setNewData(newData);
                /* dataRowにセット */
                setValue('payload.list',dataRow.list);
                /* 確認モードに変更　*/
                pageMode === 'edit' ? setPageMode('updateConfirm') : setPageMode('registerConfirm');
            };
        }
        /* デフォルトが存在しない場合にエラー */
        else{
            /* スナックバー表示 */
            setSnackbarMessage({      
                ...snackbarMessage,
                open:true,
                message:'CMNW002',
                type: 2,//APIエラー時:1,それ以外:2 
                level:'error'//エラースナックバー
            });
        }
    }
    /* === 編集ボタンを押した時の処理=== */
    const onClickSubmit = (data) =>{
        if(pageMode === 'register'){
            const oldAplyDate = new Date(dataRow.aplySrtDate);
            const newAplyDate = new Date(data.payload.aplySrtDate);
            const today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            /* 登録しようとした適用日が今日よりも前 */
            if(today > newAplyDate){
               /* スナックバー表示 */
               setSnackbarMessage({      
                ...snackbarMessage,
                open:true,
                message:'CMNW001',
                type: 2,//APIエラー時:1,それ以外:2 
                level:'error'//エラースナックバー
                })
            }
            else if(dataRow.applyList.some(e=>new Date(e.value).getTime() === newAplyDate.getTime())){
                /* スナックバー表示 */
                setSnackbarMessage({      
                 ...snackbarMessage,
                 open:true,
                 message:'CMNW006',
                 type: 2,//APIエラー時:1,それ以外:2 
                 level:'error'//エラースナックバー
                 })
             }
            /* 登録しようとした適用日がコピーしたデータよりも前 */
            else if( oldAplyDate > newAplyDate ){
                /* コピーしたデータが削除されても良いかを確認　*/
                const afterFunc = () =>{
                    /* データ確認処理　*/
                    checkEditData(data);
                }
                /* 確認ダイアログ表示 */
                setDialogMessage({      
                    ...dialogMessage,
                    open:true, 
                    message:'CMNC003',//メッセージID(commonFunctionより対象のメッセージ)
                    afterFunc:afterFunc,
                    pattern: 2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
                });
            }else{
                /* データ確認処理　*/
                checkEditData(data);
            };
        }else{
            /* データ確認処理　*/
            checkEditData(data);
        }

    };

    
    /* === 編集・完了ボタンを押した時の処理=== */
    const onClickCenter = () =>{
        if(pageMode === 'list' || pageMode === 'futureList' || pageMode === 'futureDeleteList'){
            setPageMode('edit');
        }else if(pageMode === 'updateConfirm'){
            updateData();
        }else if(pageMode === 'deleteConfirm'){
            deleteData();
        }else if(pageMode === 'registerConfirm'){
            updateData();
        };
    };

    /* ====== 削除ボタンを押した時の処理 ====== */
    const onClickRight = () =>{
        /* 変更後のデータをnewDataに入れておく */
		setNewData(getValues('payload.list'));
        /* deleteモードに変更 */
		setPageMode('deleteConfirm');
        /* dataRowにリセット */
        setValue('payload.list',dataRow.list);
    }
    /* ====== 適用日ボタン押下 ====== */
    const onChangeApply = (event) => {
        getMaster(event.target.value);
    } ;

    /* ====== コピーして登録ボタンを押下 ====== */
    const onClickCopyRegist = () =>{
        /* ====== 適用日登録時日付取得 ====== */
        var date = new Date();//今日の日付を取得
        const aplySrtDate = new Date(getValues('payload.aplySrtDate'))//今日の日付を取得
        if(aplySrtDate === date){
            date.setDate(date.getDate() + 1);
        }else if(aplySrtDate > date){
            date = aplySrtDate;
            date.setDate(aplySrtDate.getDate() + 1);
        }
        /* yyyy-mm-ddの形に変える */
        let year = date.getFullYear();//年を取得
        let month = ('00' + (date.getMonth()+1)).slice(-2)//月を取得
        let day = ('00' + (date.getDate())).slice(-2);//日を取得
        let today = year + '-' + month + '-' + day//それぞれをフォーマットになるよう結合する

        /*　日付のセット */
        setValue('payload.aplySrtDate',today);

        /* pageModeのセット */
        setPageMode('register');
    }

    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */

    
    /* ====== 適用日データ ====== */
	const applyDateTableConfig = [
        {
			id:'row1', 
			label:'適用開始日', 
			list:[
				{
					name:'aplySrtDate',
					type:'applySelect',
					applyList: 'applyList',
					clickType: 'base',
				}
			]
        }
    ];

    /* ====== 適用日データ ====== */
	const applyDateTableCnfConfig = [
        {
            id:'row1', 
            label:'適用開始日', 
            list:[
                {name:'aplySrtDate', type:'dateLabel'}
            ]
        }
    ];

    /* ====== 適用日データ ====== */
	const applyDateTableRegConfig = [
        {
            id:'row1', 
            label:'適用開始日', 
            list:[
                {name:'aplySrtDate',type:'date',pattern:'date'},
            ]
        }
    ];

    const checkUnderbarType = (pageMode) =>{
        let result;
        switch(pageMode){
            case 'list':
                result = 'edit';
            break;
            case 'futureList':
                result = 'edit';
            break;
            case 'futureDeleteList':
                result = 'editDelete';
            break;
            case 'pastList':
                result = '';
            break;
            case 'edit':
                result = 'confirmCancel';
            break;
            case 'register':
                result = 'confirmCancel';
            break;
            case 'updateConfirm':
                result = 'completeBack';
            break;
            case 'deleteConfirm':
                result = 'completeBack';
            break;
            case 'registerConfirm':
                result = 'completeBack';
            break;
            // case 'list':
            
            // break;
            // case 'list':
            
            // break;
            default:
                result = 'edit';
            break;
        }
       return result;
    };

  

    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */

    /* ====== 画面表示開始前 ====== */
    if(!loading){
        return(
        <></>
        );
    };

    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
            {/* プログレスバー */}
            <LoadingProgressBar open={progress}/>
            {/* 画面タイトル */}
            <CommonStyle.GdivTitleWrapper>
            {/* <Title text={registerMode ? `${pageTitle}適用日登録` : editMode ? `${pageTitle}編集` : pageTitle} borderBottom='none' exp='説明が表示されます'/> */}
            <Title text={'権限グループマスタ' + (pageMode.includes('Confirm') ? '確認' : pageMode === 'edit' ? '編集' : 'メンテ')} borderBottom='none'/>
            </CommonStyle.GdivTitleWrapper>
            {/* 確認文言 */}
            <CommonStyle.GdivConfirmText mode={pageMode}/>
            <CommonStyle.GdivPageContentsWrapper>
                <CommonStyle.GdivSubTitleWrapper>
                    <label style={{marginRight: '10px'}}>適用開始日情報</label>
                    {/* 一覧表示モードの時だけ表示 */}
                    { pageMode === 'futureList'  || pageMode === 'futureDeleteList' ?
                    <ButtonIconCopyRegister onClick = {()=> onClickCopyRegist()}/> : ''}
                </CommonStyle.GdivSubTitleWrapper>
                <LeftTitleTable
                    className='baseText'
                    register={register}
                    payload='payload'
                    errors={errors}
                    dataRow={pageMode === 'registerConfirm' ? confirm : dataRow}
                    tableConfig={(pageMode === 'list' || pageMode === 'futureList' || pageMode === 'pastList'|| pageMode === 'futureDeleteList') ? applyDateTableConfig : ( pageMode === 'register' ? applyDateTableRegConfig : applyDateTableCnfConfig ) }
                    onChangeApply={onChangeApply}
                />
                {/* <CommonStyle.GdivSubTitleWrapper style={{marginBottom: subTitleFlex ? '8px': '', marginTop: '10px'}}> */}
                <CommonStyle.GdivSubTitleWrapper style={{marginBottom:'8px', marginTop: '10px'}}>
                    {/* {subPageTitle} */}
                    権限グループ情報
                </CommonStyle.GdivSubTitleWrapper>                
                <form onSubmit={handleSubmit(onClickSubmit)}>
                    {pageMode !== 'updateConfirm' && pageMode !== 'registerConfirm'?
                        <TableArray
                            paperStyle={{ maxHeight: 'calc(100vh - 340px)' }}
                            headCells={(pageMode === 'list' || pageMode === 'futureList'|| pageMode === 'pastList'|| pageMode === 'futureDeleteList') ?  headData : editHeadData} //ヘッダの設定情報  
                            headCells2={headData2} //ヘッダの設定情報
                            bodyCells={(pageMode === 'list' || pageMode === 'futureList'|| pageMode === 'pastList'|| pageMode === 'futureDeleteList') ? bodyData : editBodyData} //ボディの設定情報 
                            dataRow={dataRow.list} //表示データ
                            payloadData={watch('payload').list}
                            errors={errors}
                            payload='payload'
                            register={register}
                            fieldsList={fields}
                            append={append}
                            remove={remove}
                            hoverEffect={true}
                            payloadCategory='list'
                            showBottom={true}
                            notShowSearchNumber={pageMode === 'edit' || pageMode === 'register'}
                            changeOrder={true}
                            setValue={setValue}
                            getValues={getValues}
                            editMode={pageMode === 'edit' || pageMode === 'register'}
                            changeFlags={confirm.flags}
                        />
                        :
                        <Table
                            headCells={confirmHeadData} //ヘッダの設定情報
                            headCells2={headData2} //ヘッダの設定情報
                            bodyCells={confirmBodyData} //ボディの設定情報
                            payload='payload'
                            register={register}
                            errors={errors}
                            payloadData={getValues('payload.list')}
                            dataRow={confirm.data} //表示データ
                            notShowSearchNumber={true}
                            payloadCategory={'list'}
                            changeFlags={confirm?.flags}
                        />    }
                    {/* アンダーバー */}
                    <Underbar
                        type={checkUnderbarType(pageMode)}//react-hook-form
                        onClickLeft={onClickLeft}//キャンセル・戻るボタン押下時の処理
                        onClickCenter={onClickCenter}//更新ボタン押下時の処理
                        onClickRight={onClickRight}//戻るボタン押下時の処理
                    />
                </form>
                
            </CommonStyle.GdivPageContentsWrapper>
            {/* ダイアログ */}
            <Dialog
				content={dialogMessage}
				set={setDialogMessage}
			/> 
            {/* スナックバー */}
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage}
                />
            
        </>
    );
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */ 
